<template>
    <div class="box">
    	<LoadingSpinner v-if="loading" />
    	<div v-else>
	    	<b-button v-if="accounting && !accounting.accountingplan_docoon_tenant_id" variant="primary" :disabled="!can_active" @click="goToActive">{{ $t('compta.active_e_invoicing') }}</b-button>
	    	<b-alert v-if="!can_active" variant="danger" show class="mt-2">
		    	{{ $t('compta.cant_active_e_invoicing') }}
		    	<ul>
		    		<li v-if="!accounting.tiers.tiers_rs">{{ $t('compta.e_invoice_tiers_rs') }}</li>
		    		<li v-if="!accounting.tiers.tiers_siren">{{ $t('compta.e_invoice_tiers_siren') }}</li>
		    	</ul>
		    </b-alert>

		    <div v-if="accounting && accounting.accountingplan_docoon_tenant_id">
                <div v-if="documents.length == 0">
                	{{ $t('compta.e_invoice_no_mandat') }}
                </div>
		    	<template v-else>
			    	<div class="row p-3">
	                    <div class="col-6">
	                        <h3>{{ $t('compta.docoon_document.name') }}</h3>
	                    </div>
	                    <div class="col-3">
	                        <h3>{{ $t('compta.docoon_document.date') }}</h3>
	                    </div>
	                    <div class="col-3">
	                        <h3>{{ $t('compta.docoon_document.apercu') }}</h3>
	                    </div>
	                </div>
	                <div class="trigger p-3 row" v-for="document in documents" :key="document.id">
	                	<div class="col-6">{{ document.fileName }}</div>
	                	<div class="col-3">{{ formatDate(document.creationDate) }}</div>
	                	<div class="col-3">
	                		<a href="" class="" @click.prevent="quickPreview(document.fileContent)"><font-awesome-icon :icon="['fas', 'eye']" /></a>
	               		</div>
	                </div>
	            </template>
		    </div>
    	</div>

        <b-modal size="xl" ref="modal_preview" hide-footer @hidden="pdf_content = null">
            <template v-slot:modal-title>
                {{ $t("action.previsualiser") }}
            </template>
			<iframe v-if="pdf_content != null" :src="'data:application/pdf;base64,' + pdf_content" height="1000px" width="100%" style="position:relative"></iframe>
        </b-modal>
	</div>
</template>

<script type="text/javascript">
    import Accounting from "@/mixins/Accounting.js"
    import _isEmpty from 'lodash/isEmpty'

	export default {
		name: 'AccountingEInvoicing',
		mixins: [Accounting],
		props: ['accountingplan_id'],
		data () {
			return {
				accounting: null,
				loading: true,
				documents: [],
				pdf_content: null
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
               this.loading = true
               this.accounting = await this.loadAccountingPlan(this.accountingplan_id)
               if(this.accounting.accountingplan_docoon_tenant_id) {
               		this.documents = await this.getDocoonTenantDocuments(this.accountingplan_id)
               }
               this.loading = false
			},

			async goToActive() {
				if(this.processing) return false
				this.processing = true
				await this.createDocoonTenant(this.accountingplan_id)
				this.processing = false
				this.init_component()
			},

			quickPreview(content) {
                this.$refs.modal_preview.show()
                this.pdf_content = content
			}
		},

		computed: {
			can_active() {
				return this.accounting && this.accounting.tiers.tiers_rs && this.accounting.tiers.tiers_siren
			}
		},

		components: {
			LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
		}
	}

</script>